<template>
  <div>
    <div style="margin-bottom: 10px;">
      <span>地区：{{flowDetail.area}}</span>
      <!-- <span style="margin-left:15px;">分子公司：{{flowDetail.company}}</span> -->
      <span style="margin-left:15px;">时间：{{flowDetail.time | filterTime}}</span>
      <Button
        type="primary"
        size="small"
        @click="calculateAggregate"
        style="margin:0 0 0 20px;"
        :disabled="readonly"
      >合计计算</Button>
      <Button
        type="primary"
        @click="saveTaskDetail"
        size="small"
        style="margin:0 0 0 20px;"
        :disabled="readonly"
      >保存</Button>
      <span style="color:#ed3f14">（填写过程及填写结束后请注意点击保存）</span>
    </div>
    <Table
      :columns="columns"
      border
      :data="userList"
    ></Table>
  </div>
</template>

<script>
import requestUrls from '@/lib/requestUrls'
import ajax from '@/lib/ajax'
import { formatDate } from '@/lib/tool'

export default {
  name: 'commissionTaskDetail',
  props: {
    flowDetail: {
      type: Object,
      default() {
        return {
          area: '',
          company: ''
        }
      }
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      columns: [
        {
          title: '客户经理',
          align: 'center',
          key: 'name'
        },
        {
          title: '1月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[0].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[0].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[0].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '2月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[1].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[1].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[1].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '3月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[2].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[2].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[2].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '4月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[3].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[3].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[3].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '5月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[4].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[4].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[4].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '6月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[5].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[5].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[5].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '7月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[6].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[6].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[6].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '8月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[7].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[7].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[7].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '9月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[8].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[8].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[8].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '10月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[9].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[9].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[9].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '11月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[10].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[10].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[10].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '12月',
          align: 'center',
          render: (h, params) => {
            return h('input', {
              domProps: {
                value: this.fillData[params.index].taskList[11].taskTarget,
                disabled: this.userList[params.index].disabled,
                title: this.fillData[params.index].taskList[11].taskTarget
              },
              attrs: {
                readonly: this.readonly
              },
              on: {
                input: (event) => {
                  this.fillData[params.index].taskList[11].taskTarget = event.target.value
                }
              },
              style: {
                width: '100%',
                border: '1px solid #ddd'
              }
            })
          }
        },
        {
          title: '合计',
          align: 'center',
          key: 'total',
          render: (h, params) => {
            return h('div', {
              domProps: {
                title: params.row.total
              }
            }, params.row.total)
          }
        },
      ],
      fillData: [],
      userList: []
    }
  },
  methods: {
    async saveTaskDetail() {
      this.$Spin.show()
      try {
        let taskList = []
        this.fillData.forEach(item => {
          if (item.name !== '合计') {
            item.taskList.forEach(task => {
              taskList.push({
                monthlyTask: task
              })
            })
          }
        })
        let rep = await ajax.post(requestUrls.CompanyBonus.MonthlyTaskList, taskList)
        this.$Spin.hide()
        if (rep.data.success) {
          this.$Message.success('保存成功')
          // 刷新数据
          this.refreshData()
        } else {
          this.$Message.error('保存失败')
        }
      } catch (err) {
        console.error(err)
        this.$Message.error('保存失败')
        this.$Spin.hide()
      }
    },
    async refreshData() {
      // 获取项目经理
      let rep = await ajax.get(requestUrls.User.GetUserListByRole, {
        params: {
          roleId: 30, // 客户经理角色ID
          filter: `u.selectDistrict.contains("${this.flowDetail.area}")`
        }
      })
      this.userList = []
      if (!rep.data.success) {
        return
      }

      this.userList = []
      this.fillData = []

      rep.data.result.items.forEach(item => {
        // table信息
        this.userList.push({
          name: item.name,
          total: ''
        })

        // 填写输入信息
        let taskList = []
        for (let i = 0; i < 12; i++) {
          taskList.push({
            am: item.name,
            company: this.flowDetail.company,
            filiale: this.flowDetail.area,
            id: '',
            inputMonth: ('0' + (i + 1)).substr(-2),
            inputDate: formatDate(this.flowDetail.time),
            inputYear: new Date(this.flowDetail.time).getFullYear(),
            taskTarget: '',
            verify: 2, // 2-未通过 1-通过
            verifydate: '' // 通过时间
          })
        }
        this.fillData.push(
          {
            name: item.name,
            taskList: taskList,
          }
        )
      })
      // 合计
      this.userList.push({
        name: '合计',
        total: '',
        disabled: 'disabled'
      })
      let taskList = []
      for (let i = 0; i < 12; i++) {
        taskList.push({
          taskTarget: '',
        })
      }
      this.fillData.push({
        name: '合计',
        taskList: taskList
      })

      // 获取月度任务
      let year = new Date(this.flowDetail.time).getFullYear()
      let taskRep = await ajax.get(requestUrls.CompanyBonus.GetListTask, {
        params: {
          filter: `inputYear=="${year}" and filiale=="${this.flowDetail.area}" and company == "${this.flowDetail.company}"`
        }
      })
      if (!taskRep.data.success) {
        return
      }
      for (let key in taskRep.data.result) {
        for (let i = 0; i < this.fillData.length; i++) {
          if (key === this.fillData[i].name) {
            this.fillData[i].taskList = taskRep.data.result[key]
            break
          }
        }
      }
    },
    calculateAggregate() {
      // 计算单月合计
      for (let i = 0; i < 12; i++) {
        let add = false
        for (let j = 0; j < this.fillData.length - 1; j++) {
          if (!add) {
            this.fillData[this.fillData.length - 1].taskList[i].taskTarget = 0
            add = true
          }

          let num = this.fillData[j].taskList[i].taskTarget
          if (num === '' || !num) {
            num = 0
          }
          if (isNaN(parseFloat(num))) {
            this.$Message.info('包含非数字字符（没填的不计入）')
            return
          }
          this.fillData[this.fillData.length - 1].taskList[i].taskTarget += parseFloat(num)

        }
        this.fillData[this.fillData.length - 1].taskList[i].taskTarget = this.fillData[this.fillData.length - 1].taskList[i].taskTarget.toFixed(2)
      }

      // 计算单人合计
      for (let i = 0; i < this.fillData.length; i++) {
        let add = false
        for (let j = 0; j < 12; j++) {
          if (!add) {
            this.userList[i].total = 0
            add = true
          }

          let num = this.fillData[i].taskList[j].taskTarget
          if (num === '' || !num) {
            num = 0
          }
          this.userList[i].total += parseFloat(num)
        }
        this.userList[i].total = this.userList[i].total.toFixed(2)
      }

    }
  },
  watch: {
    flowDetail: {
      async handler(val) {
        console.log(val, 2)
        if (val.company) {
          await this.refreshData()
          if (this.readonly) {
            this.calculateAggregate()
          }
        }
      },
      immediate: true,
      deep: true
    }
  },
  filters: {
    filterTime(val) {
      if (!val) {
        return ''
      }
      let time = new Date(val)
      return time.toLocaleDateString().replace(/\//g, '-')
    }
  }
}
</script>
